module.exports = __webpack_public_path__ + "static/media/fa-v4compatibility.d4a14b7a.ttf";